import React, { useEffect, useState } from 'react'
import { RootState } from '../../../global/config/store';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Autocomplete, Box, Button, FormControl, Popover, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
import { ApiGetAllocationlist, ApiGetPriceChangeLogs, ApiGetAllocationForUpdate, ApiUpdateAllocationPrice, ApiDeleteAllocationPriceChangeLogsById, ApiGetClientEntityByClientGroupId } from '../../../apiService/Core/Apicall.tsx';
import { toast } from 'react-toastify';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { useShopperDetails } from '../../../global/ShopperDetailsUtils.ts';
import Dcrage from '../OrphanAllocation/Dcrage.tsx';

function UpdatePricing() {
    const Clientlist = useSelector((state: RootState) => state.client.clientList);
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const dispatch = useDispatch()
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
    const [ClientId, setClientId] = useState(null);
    const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
    const reportMonth = selectedDate ? selectedDate.getMonth() + 1 : null;
    const reportYear = selectedDate ? selectedDate.getFullYear() : null;
    const [price, setPrice] = useState<String>();
    const [priceDisplay, setPriceDisplay] = useState<String>();
    const [task, settask] = React.useState<any[]>([]);
    const [priceChangesData, setPriceChangesData] = useState<any>([]);
    const [selectedAllocation, setSelectedAllocation] = useState<any>(null);
    const [allocationData, setAllocationData] = useState<any>([]);
    const [clientEntityId, setClientEntityId] = useState<any>(null);
    const [clientEntityList, setClientEntityList] = useState<any>([]);
    const { anchorEl, loanData, clickedShopperId, handleShopperDetailsClick, handleClose } = useShopperDetails();


    useEffect(() => {
        if (Clientlist.length > 2) {
            // setSelectedClient(Clientlist[2]);
            setClientId(Clientlist[2].clientGroupName);
        }
    }, [Clientlist]);

    useEffect(() => {
        setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        const getallocationlist = async () => {
            const data = `?offset=0&limit=1000&clientEntityId=${clientEntityId}&jobMonth=${reportMonth}&jobYear=${reportYear}`;
            try {
                const response = await ApiGetAllocationlist(data);
                settask(response.data);
                if (response.data.length > 0) {
                    setSelectedAllocation(response.data[0]);
                } else {
                    setSelectedAllocation(null);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (selectedClient && reportMonth && reportYear) {
            getallocationlist();
        }
    }, [clientEntityId, reportMonth, reportYear]);

    const handlePriceChangeLog = async () => {
        setPriceChangesData([])
        if (selectedClient?.clientGroupName) {
            const data = `?clientGroup=${selectedClient?.clientGroupName}&jobMonth=${reportMonth}&jobYear=${reportYear}`
            try {
                const res = await ApiGetPriceChangeLogs(data);
                setPriceChangesData(res?.data);
            } catch (error) {
                console.log(error)
            }
        }
    }
    useEffect(() => {
        handlePriceChangeLog();
    }, [selectedClient, reportMonth, reportYear]);

    const ApiForAllocationUpdate = async () => {
        setAllocationData([])
        if (selectedClient?.clientGroupName && selectedAllocation?.allocationId) {
            const data = `?clientGroupName=${selectedClient?.clientGroupName}&allocationId=${selectedAllocation?.allocationId}&jobMonth=${reportMonth}&jobYear=${reportYear}`
            try {
                const res = await ApiGetAllocationForUpdate(data);
                setAllocationData(res?.data)
                setPrice(res?.data?.responseData?.venuePrice)
                setPriceDisplay(res?.data?.responseData?.venuePriceDisplay)
            } catch (error) {
                console.log(error)
            }
        }
    }
    useEffect(() => {
        ApiForAllocationUpdate();
    }, [selectedClient, selectedAllocation, reportMonth, reportYear])

    const handleUpdate = async () => {
        try {
            const data = {
                jobMonth: reportMonth,
                jobYear: reportYear,
                clientGroupName: selectedClient?.clientGroupName,
                allocationId: selectedAllocation?.allocationId,
                venuePrice: String(price),
                venuePriceDisplay: priceDisplay,
                modifiedBy: localStorage.getItem("userId")
            }
            const response = await ApiUpdateAllocationPrice(data);
            toast.success(response.message);
            handlePriceChangeLog();
            ApiForAllocationUpdate();

        } catch (error) {
            console.log(error)
        }
    }
    const handleDelete = async (id) => {
        try {
            const data = `?allocationId=${id}`
            const response = await ApiDeleteAllocationPriceChangeLogsById(data);
            toast.success(response.message);
            handlePriceChangeLog();
            ApiForAllocationUpdate();
        } catch (error) {
            console.log(error)
        }
    }

    const handleGetClientList = async () => {
        if (!selectedClient?.clientGroupName) return;
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            console.log(res.data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }
    useEffect(() => {
        handleGetClientList();
    }, [selectedClient?.clientGroupName]);


    return (
        <Box className="manage-admin-container" padding='20px'>
            <Box className="d-flex align-items-center w-100 py-2 mb-5" sx={{ justifyContent: 'space-between' }}>
                <Box className='d-flex' gap={1}>
                    <Stack direction="row" className="ml-0" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) =>
                                    option.clientGroupDBName === value.clientGroupDBName
                                }
                                onChange={(event, newValue: any) => {
                                    // setSelectedClient(newValue);
                                    dispatch(setSelectedClientGroup(newValue))
                                    settask([])
                                    setSelectedAllocation([])
                                    setClientId(newValue?.clientGroupName || null);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-0" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList.filter((item) => item.clientEntityId !== null)}
                                getOptionLabel={(option) => option?.entityName || ""}
                                onChange={(event, newValue: any) => {
                                    setClientEntityId(newValue?.clientEntityId || null)
                                }}
                                value={clientEntityList.find((option) => option?.clientEntityId === clientEntityId) || null}
                                renderInput={(params) => <TextField {...params} label="Select Business" />}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack className="ml-0" direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 200 }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={task}
                                getOptionLabel={(option) => option?.venueId?.venueName || ""}
                                isOptionEqualToValue={(option, value) =>
                                    option?.allocationId === value?.allocationId
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedAllocation(newValue);
                                }}
                                value={selectedAllocation}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Allocation" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                </Box>
                <Typography fontWeight='bold' variant='h4'>Update Pricing</Typography>
                <Box sx={{ alignItems: 'flex-end', marginRight: 1 }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={["month", "year"]}
                            label=""
                            value={selectedDate}
                            onChange={(newDate) => setSelectedDate(newDate)}
                            format="MM/yyyy"
                            sx={{
                                width: "400px",
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: 1,
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
            <Box className="d-flex align-items-center w-100 py-2 mb-5 justify-content-center mr-5">
                <Typography fontWeight='20px' variant='h4' marginTop={0}>Allocation For {selectedDate ? `${(selectedDate.getMonth() + 1).toString().padStart(2, '0')}/${selectedDate.getFullYear()}` : '--/----'}</Typography>
            </Box>
            <Table>
                <TableHead>
                    <TableRow className="table-row-background">
                        <TableCell style={{ color: "#fff", }}>Status</TableCell>
                        <TableCell style={{ color: "#fff" }}>Month</TableCell>
                        <TableCell style={{ color: "#fff" }}>Store</TableCell>
                        <TableCell style={{ color: "#fff" }}>Type</TableCell>
                        <TableCell style={{ color: "#fff" }}>Shopper Name</TableCell>
                        <TableCell style={{ color: "#fff" }}>Shopper Date</TableCell>
                        <TableCell style={{ color: "#fff" }}>Shopper Time</TableCell>
                        <TableCell style={{ color: "#fff" }}>Price</TableCell>
                        <TableCell style={{ color: "#fff" }}>Price Display</TableCell>
                        <TableCell style={{ color: "#fff" }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        allocationData?.responseData ? (
                            <TableRow>
                                <TableCell>{allocationData?.responseData?.status}</TableCell>
                                <TableCell>{allocationData?.responseData?.month}/{allocationData?.responseData?.year}</TableCell>
                                <TableCell>{allocationData?.responseData?.store}</TableCell>
                                <TableCell>{allocationData?.responseData?.type}</TableCell>
                                <TableCell
                                    sx={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                        if (allocationData?.responseData?.shopperId) {
                                            handleShopperDetailsClick(e, allocationData?.responseData?.shopperId)
                                        }
                                    }}
                                >
                                    {allocationData?.responseData?.shopperName}</TableCell>
                                <TableCell>{allocationData?.responseData && new Date(allocationData?.responseData?.shopperDate)?.toISOString()?.split("T")[0]}</TableCell>
                                <TableCell>{allocationData?.responseData?.shopperTime}</TableCell>
                                <TableCell>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={price}
                                        onChange={(e) => setPrice(e.target.value)}
                                        sx={{ width: '120px' }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        value={priceDisplay}
                                        onChange={(e) => setPriceDisplay(e.target.value)}
                                        sx={{ width: '300px' }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <Button variant="contained" className="table-row-background" onClick={handleUpdate}>
                                        Update
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )
                            : <TableRow><TableCell className='text-center' colSpan={10}>No Data Found</TableCell></TableRow>
                    }

                </TableBody>
            </Table>

            <Popover
                // open={Boolean(anchorEl) && selectedIndex === index}
                open={Boolean(anchorEl) && clickedShopperId !== null}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
            >
                <Dcrage handleClose={handleClose} loanData={loanData} />
            </Popover>

            <Box className="d-flex align-items-center w-100 py-2 mb-5 justify-content-center mr-5">
                <Typography fontWeight='20px' variant='h4' marginTop={10}>Price Change Log</Typography>
            </Box>
            <Table>
                <TableHead>
                    <TableRow className="table-row-background">
                        <TableCell style={{ color: "#fff", }}></TableCell>
                        <TableCell style={{ color: "#fff" }}>Store Name</TableCell>
                        <TableCell style={{ color: "#fff" }}>Group Name</TableCell>
                        <TableCell style={{ color: "#fff" }}>Old Price</TableCell>
                        <TableCell style={{ color: "#fff" }}>Old Price Display</TableCell>
                        <TableCell style={{ color: "#fff" }}>New Price</TableCell>
                        <TableCell style={{ color: "#fff" }}>New Price Display</TableCell>
                        <TableCell style={{ color: "#fff" }}>Changed Date</TableCell>
                        <TableCell style={{ color: "#fff" }}>Change By</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {priceChangesData.length > 0 ? priceChangesData.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <Button variant="contained" className="table-row-background" onClick={() => { handleDelete(item?.allocationId) }}>
                                    Delete
                                </Button>
                            </TableCell>
                            <TableCell>{item?.venueName}</TableCell>
                            <TableCell>{item?.clientEntityName}</TableCell>
                            <TableCell>{item?.oldVenuePrice}</TableCell>
                            <TableCell>{item?.oldVenuePriceDisplay}</TableCell>
                            <TableCell>{item?.newVenuePrice}</TableCell>
                            <TableCell>{item?.newVenuePriceDisplay}</TableCell>
                            <TableCell>{new Date(item?.modifiedOn).toLocaleString("en-US", { hour12: true })}</TableCell>
                            <TableCell>{item?.changedBy}</TableCell>
                        </TableRow>
                    )) : <TableRow><TableCell className='text-center' colSpan={9}>No Data Found</TableCell></TableRow>}
                </TableBody>
            </Table>
        </Box>
    )
}
export default UpdatePricing;